import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
  selector: 'sc-user-search-dialog',
  templateUrl: './user-search-dialog.component.html',
  styleUrls: ['./user-search-dialog.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class UserSearchDialogComponent {
  customer: any;
  constructor(public dialogRef: MatDialogRef<UserSearchDialogComponent>) {}

  selectCustomer(customer) {
    this.customer = customer;
  }

  clearSearch() {
    this.customer = null;
  }
}
